export const authReducer = (prevState, action) => {
  switch (action.type) {
    case "SIGN_IN":
      return {
        ...prevState,
        user: action.user,
        userToken: action.token
      };
    case "SIGN_OUT":
      return {
        ...prevState,
        userToken: null,
        user: null
      };
    case "BLOCK_UNBLOCK_UI":
      return {
        ...prevState,
        isLoading: !prevState.isLoading
      }
    case "GET_USER":
    default:
      return prevState
  }
}